<div *ngIf="message && size === 'small'" class="message mr-3">
  {{ message }}
</div>
<div
  class="spinner-container"
  [ngClass]="{ 'spinner--small': size === 'small', 'spinner--normal': size === 'normal' }"
>
  <div class="spinner-wrapper">
    <div class="spinner"></div>
  </div>

  <div *ngIf="message && size === 'normal'" class="message">
    {{ message }}
  </div>
</div>
